import { useState, useEffect } from "react";

import { images } from "../../constants";
import { MainPageWrap } from "../../wrapper";
import { ProgressSpinner } from "../../components";
import { client } from "../../client";
import { useInView, motion } from "framer-motion";

import "./Footer.scss";
import { useRef } from "react";
import { sectionVariants } from "../../utils/animation";

const Footer = ({ handleActiveIndex }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("idle");
  const [label, setLabel] = useState(null);
  const footerRef = useRef();
  const isInView = useInView(footerRef);

  const { name, email, message } = formData;

  useEffect(() => {
    if (isInView) {
      handleActiveIndex(4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const clearInputs = () => {
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  const sendContact = async (data) => {
    try {
      await client.create(data);
      setStatus("success");
      clearInputs();
    } catch (error) {
      setStatus("error");
      clearInputs();
      setTimeout(() => {
        setStatus("idle");
      }, 2000);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("loading");

    const contact = {
      _type: "contact",
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    sendContact(contact);
  };

  useEffect(() => {
    switch (status) {
      case "idle":
        setLabel("Send Message");
        break;
      case "loading":
        setLabel(<ProgressSpinner />);
        break;
      case "success":
        setLabel(
          <div>
            Thank you <img src={images.successIcon} alt="Success icon" />
          </div>
        );
        break;
      case "error":
        setLabel(<div>Something went wrong &#128542;</div>);
        break;

      default:
        break;
    }
  }, [status]);

  return (
    <motion.div
      ref={footerRef}
      initial="hidden"
      whileInView="visible"
      variants={sectionVariants}
      viewport={{ once: true }}
      className="footer"
    >
      <h2 className="footer__title title">Take A Coffee &#38; Chat With Me</h2>
      <div className="footer__contacts">
        <div className="footer__card">
          <img src={images.email} alt="Mun email" />
          <a href="mailto:mun.ar.dev@gmail.com" className="p-text">
            mun.ar.dev@gmail.com
          </a>
        </div>
        <div className="footer__card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+998909633083" className="p-text">
            +998 (90) 963-30-83
          </a>
        </div>
      </div>
      <form
        className="footer__contact-form contact-form"
        onSubmit={handleSubmit}
      >
        <div className="contact-form__input">
          <label htmlFor="name" className="visually-hidden">
            Your Name
          </label>
          <input
            type="text"
            name="name"
            id="name"
            aria-label="Name field"
            placeholder="Your Name*"
            value={name}
            onChange={handleChangeInput}
            required
          />
        </div>
        <div className="contact-form__input">
          <label htmlFor="email" className="visually-hidden">
            Your Email
          </label>
          <input
            type="email"
            name="email"
            id="email"
            aria-label="Email field"
            placeholder="Your Email*"
            value={email}
            onChange={handleChangeInput}
            required
          />
        </div>
        <div className="contact-form__input">
          <label htmlFor="message" className="visually-hidden">
            Your Message
          </label>
          <textarea
            name="message"
            id="message"
            aria-label="Message field"
            cols="30"
            rows="10"
            placeholder="Your Message*"
            value={message}
            onChange={handleChangeInput}
            required
          ></textarea>
        </div>
        <button
          type="submit"
          className={`contact-form__btn ${status === "error" ? "error" : ""}`}
        >
          {label}
        </button>
      </form>
    </motion.div>
  );
};

export default MainPageWrap(Footer, "contact");
